import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import HFOptionGroup from 'components/HFInputs/HFOptionGroup'
import HFTextInput from 'components/HFInputs/HFTextInput'
import HFDatepicker from 'components/HFInputs/HFDatepicker'
import { useFormContext } from 'react-hook-form'
import { booleanOptions } from 'controllers/TaskManager/formOptions'

import styles from '../../Dialog.module.sass'

/**
 * Hospitalization fields (floor, bed, service, discharge forecast).
 *
 * Rendered under the "Hospitalization" option of the Trust-network following
 * reason. The parent keeps `clinicalAssistance.injuredHospitalized` in sync so
 * the provider selection, validation and backend stay unchanged.
 */
export const HospitalizationFields = () => {
	const { i18n } = useGlobal()
	const { watch } = useFormContext()

	const [dischargeForecast] = watch(['clinicalAssistance.dischargeForecast'])

	return (
		<>
			<HStack gap='xsmall'>
				<VStack className={styles['form-input']}>
					<h5>{i18n`Floor`}</h5>
					<HFTextInput
						name='clinicalAssistance.floor'
						multiline={false}
						rows={5}
						noResize
					/>
				</VStack>

				<VStack className={styles['form-input']}>
					<h5>{i18n`Bed`}</h5>
					<HFTextInput
						name='clinicalAssistance.bed'
						multiline={false}
						rows={5}
						noResize
					/>
				</VStack>
			</HStack>

			<VStack className={styles['form-input']}>
				<h5>{i18n`Service`}</h5>
				<HFTextInput
					name='clinicalAssistance.service'
					multiline={false}
					rows={5}
					noResize
				/>
			</VStack>

			<VStack className={styles['form-input']}>
				<h5>{i18n`Has a discharge forecast?`}</h5>
				<HFOptionGroup
					className={`${styles['option-group']} ${styles['--horizontal-flex']}`}
					name='clinicalAssistance.dischargeForecast'
					type='boolean'
					options={booleanOptions}
				/>
			</VStack>

			{dischargeForecast && (
				<VStack className={styles['form-input']}>
					<h5>{i18n`When ?`}</h5>
					<HFDatepicker
						name='clinicalAssistance.dischargeForecastDate'
						type='date'
					/>
				</VStack>
			)}
		</>
	)
}
